import { SearchIcon } from "@chakra-ui/icons";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  Flex,
  Box,
  InputGroup,
  InputRightElement,
  Input,
  Stack,
  Text,
  Divider,
  Button,
  useToast,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";
import addgroup from "@/assets/addgroup.svg"
import { ReactSVG } from "react-svg";
import { useState } from "react";
import { useCreateContentGroupMutation, useGetContentGroupListQuery } from "@/services/api/endpoints/contentGroup";
import { ContentGroup as ContentGroupType } from "@/types/contentgroup";
import { ServerError } from "@/types/errors";
import { FormikErrors } from "formik/dist/types";
type Props = {
  isOpen: boolean;
  userId: string;
  onClose: () => void;
  setFieldValue:(field: string, value: any, shouldValidate?: boolean | undefined)=>Promise<void | FormikErrors<ContentGroupType>>
}

const ContentGroup = (props: Props) => {
  const toast = useToast()
  const [value, setValue] = useState('')
  const [showAdd, setShowAdd] = useState(true)
  const [groupName, setGroupName] = useState('')
  const [search, setSearch] = useState('')
  const { data } = useGetContentGroupListQuery({ user_id: props.userId, group_name: search })
  const [createContentGroup] = useCreateContentGroupMutation()
  
  const handleChoise= (value:string)=>{
    setValue(value)
    const contentGroup = data?.find(item=>item.id==value)
    props.setFieldValue("group_id",contentGroup?.id,false)
    props.setFieldValue("group_name",contentGroup?.group_name,false)
    props.onClose()
  }
  const handleSave = async () => {
    const data = {
      group_name: groupName,
      user_id: "123"
    }
    await createContentGroup(data).unwrap().catch((e) => {
      toast({
        title: (e as ServerError).message,
        position: 'top',
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    });
  }
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} isCentered scrollBehavior="inside" autoFocus onCloseComplete={() => setShowAdd(true)}>
      <ModalOverlay />
      <ModalContent >
        <ModalHeader>分组选择</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box pl="10px" pr="10px">
            <InputGroup size='md' mb="20px">
              <Input placeholder='请输入查询内容' onChange={(e) => setSearch(e.target.value)} />
              <InputRightElement >
                <SearchIcon cursor={"pointer"} />
              </InputRightElement>
            </InputGroup>
            <RadioGroup onChange={handleChoise} value={value}>
              <Stack>
                {
                  data && data.map((item, index) => (
                    <Box key={index} height={"40px"} _hover={{ bg: "#dedede" }} lineHeight={"40px"}>
                      <Radio value={item.id} w={"100%"}>{item.group_name}</Radio>
                    </Box>
                  ))
                }
              </Stack>
            </RadioGroup>


            <Divider mt="20px" />
            <Flex mt="34px" mb="20px" hidden={!showAdd}>
              <ReactSVG src={addgroup} beforeInjection={(svg) => svg.setAttribute("style", "width:18px;height:18px")} />
              <Text onClick={() => setShowAdd(false)} cursor={"pointer"} ml="10px" fontSize="14px">添加分组</Text>
            </Flex>
            <InputGroup size='md' hidden={showAdd} mt="34px" mb="20px">
              <Input value={groupName} onChange={(e) => setGroupName(e.target.value)} placeholder='请输入分组' maxLength={20} />
              <InputRightElement width='8rem'>
                <Button size='sm' fontSize="12px" color="#27314D" onClick={() => setShowAdd(true)}>取消</Button>
                <Button size='sm' fontSize="12px" ml="10px" mr="10px" colorScheme='blue' onClick={handleSave}>确定</Button>
              </InputRightElement>
            </InputGroup>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ContentGroup

